define.alias("ember-cli-string-helpers/helpers/truncate", "media/helpers/truncate");